import Statistics from '../components/Home/Statistics';
import RequestsTable from '../components/Home/RequestsTable';
import SectionWrapper from '@/components/atoms/SectionWrapper';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t } = useTranslation();

  return (
    <SectionWrapper
      title={t('home.applicantsRequests')}
      desc={t('home.applicantsRequestsTableDesc')}
    >
      <div className="space-y-6">
        <Statistics />
        <RequestsTable />
      </div>
    </SectionWrapper>
  );
};

export default Home;
